(() => {
function buildFilterUrl(params, param, valuesToSet) {
  const updated = new URLSearchParams(params);
  updated.delete(param);
  valuesToSet.forEach((v) => updated.append(param, v));
  const qs = updated.toString();
  return qs ? window.location.pathname + '?' + qs : window.location.pathname;
}

function syncPills() {
  const params = new URLSearchParams(window.location.search);

  document.querySelectorAll('[data-plp-pills]').forEach((list) => {
    const param = list.dataset.filterParam;
    if (!param) return;
    const active = params.getAll(param);
    let anyActive = false;

    list.querySelectorAll('.plp-species-pills__pill').forEach((pill) => {
      if (pill.hasAttribute('data-all-pill')) return;
      const value = pill.dataset.filterValue;
      const isActive = active.includes(value);
      pill.classList.toggle('plp-species-pills__pill--active', isActive);
      if (isActive) {
        pill.setAttribute('aria-current', 'true');
        anyActive = true;
      } else {
        pill.removeAttribute('aria-current');
      }

      const newValues = isActive
        ? active.filter((v) => v !== value)
        : active.concat(value);
      pill.href = buildFilterUrl(params, param, newValues);
    });

    const allPill = list.querySelector('[data-all-pill]');
    if (allPill) {
      allPill.classList.toggle('plp-species-pills__pill--active', !anyActive);
      if (anyActive) {
        allPill.removeAttribute('aria-current');
      } else {
        allPill.setAttribute('aria-current', 'true');
      }
      allPill.href = buildFilterUrl(params, param, []);
    }
  });
}

function getFacetsForm() {
  for (const el of document.querySelectorAll('facets-form-component')) {
    if (!el.closest('dialog-component')) return el;
  }
  return null;
}

function handlePillClick(event) {
  const pill = event.target.closest('.plp-species-pills__pill');
  if (!pill) return;

  if (pill.getAttribute('aria-disabled') === 'true') {
    event.preventDefault();
    return;
  }

  const facetsForm = getFacetsForm();
  if (!facetsForm || typeof facetsForm.updateFiltersByURL !== 'function') return;

  event.preventDefault();
  facetsForm.updateFiltersByURL(pill.href);
}

document.querySelectorAll('[data-plp-pills]').forEach((list) => {
  list.addEventListener('click', handlePillClick);
});

document.addEventListener('filter:update', syncPills);
})();
